// extracted by mini-css-extract-plugin
export default {"card":"Card_card__IC3PU","header":"Card_header__oZAPO","image":"Card_image__dEqih","button":"Card_button__szIS5"};